import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { transparentize } from 'polished';
import { useTranslation } from 'react-i18next';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';
import { paginationSettingsMotion } from '../../../../motion';
import { IconWrapper, PaginationWarning, TextWrapper } from './DisabledPaginationInfo.styles';

var DisabledPaginationInfo = function DisabledPaginationInfo(_ref) {
  var paginationDisabled = _ref.paginationDisabled;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement(AnimatePresence, {
    initial: false
  }, paginationDisabled && React.createElement(motion.div, Object.assign({}, paginationSettingsMotion, {
    style: {
      overflow: 'hidden'
    }
  }), React.createElement(PaginationWarning, null, React.createElement(IconWrapper, null, React.createElement(Icon, {
    type: "info",
    width: 14,
    height: 14,
    fill: transparentize(0.2, colors.black[100])
  })), React.createElement(TextWrapper, null, React.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400
  }, t('widget_customization_table_settings.disabled_pagination_info'))))));
};

export default DisabledPaginationInfo;